<template>
  <div class="container fixed-header-container"
       :class="{'with-banner': showBetaBanner && !bannerHidden, 'fixed-header-container-padding': this.isLoggedIn }"
       :style="{'--corp-color': colorFilters}"
       id="app">
    <template v-if="corporation">
      <play-aloud-text v-if="corporation.accessibility_on"></play-aloud-text>
      <!-- Common components -->
      <course-enroll-modal :requisites="requisites"
                           :course-id="enrollCourseID"
                           :show-dialog="openEnroll">
      </course-enroll-modal>

      <wait-list-modal v-model="openWaitListModal"
                       @refresh="refresh"
                       :message="waitlistMessage">
      </wait-list-modal>



      <wait-list-remove-modal v-model="openWaitListRemoveModal"
      				   :id-course="waitListCourseID"
                       @refresh="refresh"
                       :message="waitlistMessage"
                       custom_waitlist="{}">
      </wait-list-remove-modal>

      <login-modal :corporation="corporation"
                   :modal-view="sessionModalView"
                   @change-view="sessionModalView = $event"
                   @refresh-session="stayAlive()"
                   :show-dialog="openLogin">
      </login-modal>
      <main-header @open-login="openLoginDialog()"
                   @hide-banner="hideBanner()"
                   :show-banner="showBetaBanner"
                   :banner-hidden="bannerHidden"
                   :catalogues="corporation.catalogues"
                   @open-signup="openSignUpDialog()">
      </main-header>
      <!-- End common components -->

      <jumbotron-header v-if="!hasCategoriesFilters" v-model="filters"></jumbotron-header>
      <filters-panel v-if="corporation.marketplace_show_filters && !hasCategoriesFilters && hasCourses"
                     v-model="filters">
      </filters-panel>

      <nav v-if="hasCategoriesFilters"
           class="d-none d-sm-block px-4 "
           aria-label="breadcrumb">
        <ol class="breadcrumb mt-3">
          <li class="breadcrumb-item">
            <a :href="PAGES.LIST"
              :style="{color: _.get(corporation, 'color_filters', null) }">
                {{t('Home')}}
            </a>
          </li>
          <li class="breadcrumb-item pr-2"
              :class="{'active': index+1 === categoriesValues.length || hasInstructors }"
              v-for="(item, index) in categoriesValues">
            <template v-if="index+1 !== categoriesValues.length && !hasInstructors">
              <a :href="getPath(index)"
                 :style="{color: _.get(corporation, 'color_filters', null) }">
                {{item | toStartCase}}
              </a>
            </template>
            <template v-else>
              {{item | toStartCase}}
            </template>
          </li>
        </ol>
      </nav>
      
      <div v-if="mainCategory && mainCategory.category_description!=`` && Object.keys($route.params||{}).length > 0"
           class="col-12 position-relative px-4 py-3">
        {{mainCategory.category_description}}
      </div>


      <div v-if="mainCategory && Object.keys($route.params||{}).length > 0"
           class="col-12 position-relative text-center pl-0 pr-0"
           style="height: 330px">
        <img :src="mainCategory.imageURL" class="img-fluid">
        <h1 class="category-title position-absolute">
            {{mainCategory.category_name}}
        </h1>
      </div>

      <categories-carousel v-if="hasCategoriesFilters && mainCategory"
                           :parent-id="mainCategory.id_category"
                           class="mt-4">
      </categories-carousel>

      <div class="instructor-container container-fluid" v-if="hasInstructors">
        <div class="row" v-if="instructor">
          <div class="col-12 instructor-header mb-4">
            <img :src="instructor.user.profile_picture ? `/files/profile/${instructor.user.profile_picture}` : '/webroot/images/user_placeholder.jpg'" class="rounded-circle mb-4 mb-lg-0" :alt="instructor.user.email" />
            <div>
              <div class="instructor-name">{{ instructor.user.name }} {{ instructor.user.lastname }}</div>
              <div v-if="instructor.instructorProfile" class="instructor-summary mb-5 pb-5" v-html="$sanitize(instructor.instructorProfile.summary)"></div>
              <div class="b-lg-5 pb-lg-5"></div>
              
              <div class="instructor-data">
                <div class="instructor-social" v-if="instructor.instructorProfile">
                <a v-if="!!instructor.instructorProfile.site" :href="instructor.instructorProfile.site" target="_blank" class="mr-2 mb-2"><WorldIcon height="24" width="24" :iconColor="'#FFFFFF'" /></a>
                      <a v-if="!!instructor.instructorProfile.facebook" :href="instructor.instructorProfile.facebook" target="_blank" class="mr-2 mb-2"><facebookIcon height="24" width="24" :iconColor="'#FFFFFF'" /></a>
                      <a v-if="!!instructor.instructorProfile.linkedin" :href="instructor.instructorProfile.linkedin" target="_blank" class="mr-2 mb-2"><linkedinIcon height="24" width="24" :iconColor="'#FFFFFF'" /></a>
                      <a v-if="!!instructor.instructorProfile.youtube" :href="instructor.instructorProfile.youtube" target="_blank" class="mr-2 mb-2"><youtubeIcon height="24" width="24" :iconColor="'#FFFFFF'" /></a>
                      <a v-if="!!instructor.instructorProfile.instagram" :href="instructor.instructorProfile.instagram" target="_blank" class="mr-2 mb-2"><instagramIcon height="24" width="24" :iconColor="'#FFFFFF'" /></a>
                      <a v-if="!!instructor.instructorProfile.twitter" :href="instructor.instructorProfile.twitter" target="_blank" class="mr-2 mb-2"><twitterXIcon height="24" width="24" :iconColor="'#FFFFFF'" /></a>
                      <a v-if="!!instructor.instructorProfile.pinterest" :href="instructor.instructorProfile.pinterest" target="_blank" class="mr-2 mb-2"><pinterestIcon height="24" width="24" :iconColor="'#FFFFFF'" /></a>
              </div>

              <div class="instructor-courses-container d-none d-lg-block" ref="instructorCoursesContainer">
                <div class="instructor-courses" ref="instructorCoursesFixed">
                  <p class="instructor-title">{{ t('Instructor in:') }}</p>
                  <span class="instructor-course" @click="openCourse(course)" :class="{ 'has-date': showStartDate(course) }" v-for="course in instructor.courses" :key="course.id">
                    <div class="instructor-course-cal" v-if="showStartDate(course)">
                      <div class="instructor-course-cal-month">{{ mergeDateTime(course.course_start_date, course.course_start_hour) | formatShortMonth(timezoneHelper(course)) }}</div>
                      <div class="instructor-course-cal-day">{{ mergeDateTime(course.course_start_date, course.course_start_hour) | formatDay(timezoneHelper(course)) }}</div>
                      <div class="instructor-course-cal-hour" v-if="course.course_start_hour && course.course_start_hour!='00:00:00'">{{ mergeDateTime(course.course_start_date, course.course_start_hour) | formatTime(timezoneHelper(course)) }}</div>
                    </div>
                    <div>
                      <p class="instructor-course-title">{{ course.course_name }}</p>
                      <p class="instructor-course-type">
                        <template  v-if="course.course_type === 'online'">
                              <OnlineIcon :isDarker="true" width="18" height="18" />
                              <span class="online-label">{{ t('ONLINE EVENT') }}</span>
                          </template>
                          <template  v-if="course.course_type === 'onsite'">
                              <OnsiteIcon :isDarker="true" width="18" height="18" />
                              <span class="address-label" v-if="course.locations.length">{{ locationCity(course.locations[0]) }}</span>
                              <span class="online-label" v-else>{{ t('ONSITE EVENT') }}</span>
                          </template>
                          <template  v-if="course.course_type === 'blended'">
                              <BlendedIcon :isDarker="true" width="18" height="18" />
                              <span class="online-label">{{ t('BLENDED EVENT') }}</span>
                          </template>
                        </p>
                      <p class="instructor-course-price">{{ getPrice(course.seats) }}</p>
                    </div>
                  </span>
                </div>
              </div><!--.instructor-courses-container-->
              </div>
            </div>
          </div>

          <div class="row col-12">
            <div class="col-12 instructor-courses-container d-lg-none mb-4">
                <div class="instructor-courses">
                  <p class="instructor-title">{{ t('Instructor in:') }}</p>
                  <span class="instructor-course" @click="openCourse(course)" :class="{ 'has-date': showStartDate(course) }" v-for="course in instructor.courses" :key="course.id">
                    <div class="instructor-course-cal" v-if="showStartDate(course)">
                      <div class="instructor-course-cal-month">{{ mergeDateTime(course.course_start_date, course.course_start_hour) | formatShortMonth(timezoneHelper(course)) }}</div>
                      <div class="instructor-course-cal-day">{{ mergeDateTime(course.course_start_date, course.course_start_hour) | formatDay(timezoneHelper(course)) }}</div>
                      <div class="instructor-course-cal-hour" v-if="course.course_start_hour && course.course_start_hour!='00:00:00'">{{ mergeDateTime(course.course_start_date, course.course_start_hour) | formatTime(timezoneHelper(course)) }}</div>
                    </div>
                    <div>
                      <p class="instructor-course-title">{{ course.course_name }}</p>
                      <p class="instructor-course-type">
                        <template  v-if="course.course_type === 'online'">
                              <OnlineIcon :isDarker="true" width="18" height="18" />
                              <span class="online-label">{{ t('ONLINE EVENT') }}</span>
                          </template>
                          <template  v-if="course.course_type === 'onsite'">
                              <OnsiteIcon :isDarker="true" width="18" height="18" />
                              <span class="address-label" v-if="course.locations.length">{{ locationCity(course.locations[0]) }}</span>
                              <span class="online-label" v-else>{{ t('ONSITE EVENT') }}</span>
                          </template>
                          <template  v-if="course.course_type === 'blended'">
                              <BlendedIcon :isDarker="true" width="18" height="18" />
                              <span class="online-label">{{ t('BLENDED EVENT') }}</span>
                          </template>
                        </p>
                      <p class="instructor-course-price">{{ getPrice(course.seats) }}</p>
                    </div>
                  </span>
                </div>
              </div><!--.instructor-courses-container-->

            <div class="col-12 instructor-data" v-if="instructor.instructorProfile && instructor.instructorProfile.about">
              <div>
                <span class="instructor-title">{{ t('Biography') }}</span>
                <div class="instructor-description" v-html="$sanitize(instructor.instructorProfile.about)"></div>
              </div>
              <div></div>
            </div>
            <div class="col-12 instructor-data" v-if="instructor.instructorProfile && instructor.instructorProfile.areas">
              <div>
                <span class="instructor-title">{{ t('Areas of expertice') }}</span>
                <div class="instructor-description" v-html="$sanitize(instructor.instructorProfile.areas)"></div>
              </div>
              <div></div>
            </div>
            <div class="col-12 instructor-data" v-if="instructor.instructorProfile && instructor.instructorProfile.idea">
              <div>
                <span class="instructor-title">{{ t('An idea worth spreading') }}</span>
                <div class="instructor-description" v-html="$sanitize(instructor.instructorProfile.idea)"></div>
              </div>
              <div></div>
            </div>
          </div>
        </div>
      </div>

      <div class="filters-form" v-if="!hasInstructors">
        <div class="row">
          <div v-if="false" class="col-12 px-5 pt-4 d-block d-sm-none">
            <div class="btn-group background-active ml-3" data-toggle="buttons">
              <label :class="{'active': listType === 'list'}"
                     @click="changeType('list')"
                     :style="{
                        borderColor: _.get(corporation, 'color_filters', null),
                        backgroundColor: listType === 'list' ? _.get(corporation, 'color_filters', null) : null,
                     }"
                     class="btn p-md-left-right">
                <i class="fa fa-th-large"
                   :style="{ color: listType !== 'list' ? _.get(corporation, 'color_filters', null) : null}"
                   aria-hidden="true">
                </i>
              </label>

              <label v-if="false" :class="{'active': listType === 'map'}"
                     @click="changeType('map')"
                     :style="{
                        borderColor: _.get(corporation, 'color_filters', null),
                        backgroundColor: listType === 'map' ? _.get(corporation, 'color_filters', null) : null,
                     }"
                     class="btn p-md-left-right">
                <i class="fa fa-map-marker"
                   :style="{ color: listType !== 'map' ? _.get(corporation, 'color_filters', null) : null}"
                   aria-hidden="true">
                </i>
              </label>
            </div>
          </div>
        </div>

        <div class="row px-5 py-4">
          <div class="col-12 col-md-8 col-lg-8 d-flex flex-column flex-sm-row justify-content-sm-between align-items-sm-center mb-sm-2 mb-md-0">
            <div class="mr-md-2">
              <toggle @change="filterOnlineCourses" :param="filters"
                      :main-color="corporation.color_filters"
                      :value="_.get(filters, 'mode', false) === 'online'"/>

              <span :style="{color: _.get(corporation, 'color_filters', null)}"
                    class="switch-text ml-2">
                {{t('Online events only')}}
              </span>



            </div>
             <form v-if="this.isLoggedIn" class="filters-form" style="top: 0;">
               <div class=" btn-group" data-toggle="buttons">
                                <label :class="{active: sharedWithMe }"
                                       @click="changeSharedWithMe()"
                                       style="align-items: center; display: flex; height: 40px; top: 0;
    									padding: 4px 16px !important;"
                                       :style="{
                                            borderColor: _.get(corporation, 'color_filters', null),
                                            backgroundColor: _.get(corporation, 'color_filters', '#256ab3'),
                                            boxShadow: _.get(corporation, 'color_filters', '0px 2px 6px rgb(37 106 179 / 50%)'),
                                        }"
                                       class="btn btn-primary p-md-left-right mb-0">

                                    {{t('Private Events')}}
                                </label>
             	</div>
             </form>



          </div>

          <div ref="filtersSection"
               class="col-md-4 col-12  col-lg-4 form-inline">


            <div class="btn-group views-selection justify-content-end background-active d-none d-sm-inline-flex mx-auto"
                 style="width: 282px"
                 data-toggle="buttons">
              <label :class="{'active': listType === 'list'}"
                     @click="changeType('list')"
                     :style="{
                        borderColor: _.get(corporation, 'color_filters', null),
                        backgroundColor: listType === 'list' ? _.get(corporation, 'color_filters', null) : null,
                     }"
                     class="btn btn-primary px-2 py-2">
                <i class="fa fa-th-large"
                   :style="{ color: listType !== 'list' ? _.get(corporation, 'color_filters', null) : null}"
                   aria-hidden="true"></i>
              </label>

              <label :class="{'active': listType === 'grid'}"
                     @click="changeType('grid')"
                     :style="{
                        borderColor: _.get(corporation, 'color_filters', null),
                        backgroundColor: listType === 'grid' ? _.get(corporation, 'color_filters', null) : null,
                     }"
                     class="btn btn-primary px-2 py-2">
                <i class="fa fa-list"
                   :style="{ color: listType !== 'grid' ? _.get(corporation, 'color_filters', null) : null}"
                   aria-hidden="true"></i>
              </label>

              <label v-if="false" :class="{'active': listType === 'map'}"
                     @click="changeType('map')"
                     :style="{
                      borderColor: _.get(corporation, 'color_filters', null),
                      backgroundColor: listType === 'map' ? _.get(corporation, 'color_filters', null) : null,
                     }"
                     class="btn px-2 py-2">
                <i class="fa fa-map-marker"
                   :style="{ color: listType !== 'map' ? _.get(corporation, 'color_filters', null) : null}"
                   aria-hidden="true"></i>
              </label>
            </div>
          </div>
        </div>
      </div>

      <template v-if="hasCourses && coursesLoaded">
        <div class="container-fluid bg-white">
          <div v-if="listType === 'list'"
              class="row flex-column flex-sm-row justify-content-sm-around pb-5 mb-5 cards-container">
            <course-card v-for="item in courses"
                        :corporation="corporation"
                        @enroll="enroll"
                        @wait-list="addToWaitList"
                        @remove-from-wait-list="removeFromWaitList"
                        :course="item"
                        :key="item.id">
            </course-card>
            <!-- Extra items to fill the void -->
            <CourseCard :course="{}" :isVoid="true" />
            <CourseCard :course="{}" :isVoid="true" />
            <CourseCard :course="{}" :isVoid="true" />
            <CourseCard :course="{}" :isVoid="true" />
            <CourseCard :course="{}" :isVoid="true" />

            <div ref="loadMoreBtnContainer" class="col-12 mt-5">
              <b-button variant="outline-primary"
                        v-if="showLoadBtn"
                        @click="loadMore()"
                        class="w-100">
                {{t('View more')}}
              </b-button>
            </div>
          </div>

          <div v-else-if="listType === 'grid'"
              class="row pb-5 mb-5">
            <div class="list-tile container-fluid mt-5">
              <CoursesGrid :courses="courses" @enroll="enroll" />
            </div>

            <div class="col-12 mt-5">
              <b-button variant="outline-primary"
                        v-if="showLoadBtn"
                        @click="loadMore()"
                        class="w-100">
                {{t('View more')}}
              </b-button>
            </div>
          </div>

          <div v-else-if="listType === 'map'"
              class="row pb-5 mb-5">
            <div class="table-responsive grid mt-5">
              <courses-map :courses="courses"
                          @enroll="enroll">
              </courses-map>
            </div>
          </div>
        </div><!-- .container-fluid -->
      </template>

      <template v-else-if="!coursesLoaded"><div class="my-5 py-5"></div></template>

      <template v-else-if="coursesLoaded && filters && (filters.keyword || (!hasCourses && !filters.keyword))">
        <div class="d-flex align-items-center justify-content-center my-5 py-5" style="gap: 28px;">
          <ArtSearchingIcon />
          <div class="no-results">
            <h1>{{ t('Sorry ! No results found') }}</h1>
            <p>{{ t("We couldn't find a matching event, please try adjusting your search to find what you're looking for.") }}</p>
          </div>
        </div>
      </template>

      <template v-else-if="isAdmin">
        <div class="row text-center empty-section">
          <div class="col-12 mt-5">
              <img src="/webroot/images/admin_emptyCourses.png" >
          </div>
          <div class="col-12 mt-4 mb-3">
            <a href="/apprendo/dashboard#/createCourse" class="admin-btn mt-1">
              {{t('Launch your first event here')}}
            </a>
            <p class="mt-3">
              {{t("There are no events yet. Let's fix that!")}} <br>
              {{t('Go to your personal menu and click on Create to get started.')}}
            </p>
          </div>
        </div>
      </template>

      <template v-else>
        <div class="row text-center empty-section">
          <div class="col-12 mt-5">
            <img src="/webroot/images/learner_emptyCourses.png" >
          </div>
          <div class="col-12 mt-3 mb-5 pb-5">
            <h3>{{t('Hello there !')}}</h3>
            <p>
              {{t('Please come back later,')}} <br>
              {{t('we are getting some events ready for you.')}}
            </p>
          </div>
        </div>
      </template>

      <transition name="fade">
        <div @click="scrollTop()"
             v-if="listType !== 'map' && showTopBtn"
             :style="{backgroundColor: colorFilters}"
             v-tooltip="{ placement: 'left', classes: 'fade bs-tooltip-left tooltip-primary show', content: t('Scroll Top') }"
             class="top-circle d-none d-sm-block waves-effect waves-themed">
             <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg">
              <path d="M11.963 2.001a.503.503 0 01.4.155l-.045-.039.026.02 9.5 9a.5.5 0 01-.617.782l-.07-.056-8.681-8.224V21.5a.5.5 0 01-.992.09l-.008-.09V3.683l-8.632 8.18-.07.056a.5.5 0 01-.618-.782l9.396-8.902a.5.5 0 01.334-.227z" fill="#fff" fill-rule="nonzero"/>
             </svg>
        </div>

      </transition>

      <list-footer></list-footer>

       <!-- first name validation -->
      <md-dialog
              :md-active.sync="showModal"
              :md-click-outside-to-close="false"
               class="modal-apply-application">
              <div class="modal-content" style="background-color: #F5F6F8;">
                <div class="modal-body p-4">
                <div class="app-info d-flex flex-column">
                  <div class="d-flex justify-content-center pb-4 pt-3"><SeatComputerIcon /></div>
                    <div class="col-md-12">

                            <h2 class="title" style="text-align: center;">{{t('Please provide your First and Last Name')}}</h2>
                             <p style="text-align: center;font-size: 16px;">{{ t('Complete the following field to continue.') }}</p>
                    </div>
                        </div>
                <div class="row">
                                <div class="col-md-12">
                  <input class="ng-element el-input-without-label interactive font-G-adqqawk3cmg56rbeecg50wkf-n4"  @keyup.enter="setFirstName" autocomplete="none" spellcheck="false" type="text" 
                  v-bind:placeholder="t('Enter your first name and last name')" v-model="userFirstName" style="opacity: 1; mix-blend-mode: normal; background-color: rgb(255, 255, 255); border-color: rgb(37, 106, 179); border-width: 1px; color: rgb(56, 56, 56); padding: 0px 8px; text-align: center; border-radius: 4px; font-size: 16px; font-weight: normal; font-style: normal; background-image: none; background-position: center center; background-repeat: repeat; background-size: cover; border-style: solid; width: 480px; height: 48px;">
                                </div></div>
                  <p></p><br/>
                   <div class="app-actions">

                    <button v-if="!showLoader" @click="setFirstName" type="button" class="mt-2 mb-3" v-bind:class="{'disabledFirstName': validationFullName() == false, 'enableFirstName': validationFullName() == true}"
                                       :disabled="validationFullName() == false">
                                    {{t('Save and continue')}}
                                </button>

                   </div>
                </div>
              </div>
      </md-dialog>
      <!-- first name validation -->

    </template>
  </div>


</template>

<script>
import DOMPurify from 'dompurify';
import API from '@/api/index';
import MainHeader from '@/components/layout/MainHeader';
import ListFooter from '@/components/layout/ListFooter';
import CourseCard from '@/components/CourseCardV2';
import Toggle from '@/components/Toggle';
import JumbotronHeader from './components/JumbotronHeader';
import FiltersPanel from './components/FiltersPanel';
import CoursesGrid from './components/CoursesGrid';
import CoursesMap from './components/CoursesMap';
import SessionManageMixin from '@/mixins/SessionManageMixin';
import BetaBanner from '@/mixins/BetaBanner';

import LoginModal from '@/components/layout/LoginModal';
import CourseEnrollModal from '@/components/CourseEnrollModal';
import {PAGES, CATEGORIES_TYPES} from '@/utils/index';
import CategoriesCarousel from "./components/CategoriesCarousel";
import PlayAloudText from '@/components/PlayAloudText';
import SafeGuardBoxRed from '@/components/SafeGuardBoxRed';

import WaitListModal from '@/components/WaitListModal';

import WaitListRemoveModal from '@/components/WaitListRemove';

import SeatComputerIcon from '@/components/Icons/SeatComputerIcon';

import ArtSearchingIcon from '@/components/Icons/ArtSearchingIcon';

import {  mapState, mapMutations, mapActions } from "vuex";

import {getRootCssCorporation} from '@/utils/common.js';

import WorldIcon from '@/components/Icons/WorldIcon';
import facebookIcon from '@/components/Icons/facebookIcon';
import linkedinIcon from '@/components/Icons/linkedinIcon';
import youtubeIcon from '@/components/Icons/youtubeIcon';
import instagramIcon from '@/components/Icons/instagramIcon';
import twitterXIcon from '@/components/Icons/twitterXIcon';
import pinterestIcon from '@/components/Icons/pinterestIcon';

import FormattingMixin from '@/mixins/FormattingMixin';

import OnlineIcon from '@/components/Icons/OnlineIcon';
import OnsiteIcon from '@/components/Icons/OnsiteIcon';
import BlendedIcon from '@/components/Icons/BlendedIcon';

const DEFAULT_FILTERS = {
  type: '',
  level: '',
  language: '',
  keyword: '',
  topics: '',
  department: '',
  mode: '',
  age: '',
  price: '',
  location: '',
  starts: '',
  time_inthe: '',
  time_on: '',
  sort: 'most recent'
};

export default {
    mixins: [
      SessionManageMixin,
      BetaBanner,
      FormattingMixin,
    ],
    components: {
      WaitListRemoveModal,
      WaitListModal,
      PlayAloudText,
      CategoriesCarousel,
      MainHeader,
      JumbotronHeader,
      FiltersPanel,
      CoursesGrid,
      CourseCard,
      CoursesMap,
      LoginModal,
      CourseEnrollModal,
      ListFooter,
      Toggle,
      SafeGuardBoxRed,
      SeatComputerIcon,
      ArtSearchingIcon,
      WorldIcon,
      facebookIcon,
      linkedinIcon,
      youtubeIcon,
      instagramIcon,
      twitterXIcon,
      pinterestIcon,
      OnlineIcon,
      OnsiteIcon,
      BlendedIcon,
    },
    data() {
        return {
          //listType: 'list',
          sortValue: 'most recent',
          limit: 12,
          filters: null,
          courses: [],
          count: 0,
          showTopBtn: false,
          mainCategory: null,
          subCategories: [],
          sharedWithMe : false,
          showFirstNametModal : false,
          userFirstName: '',
          userData: {},
          coursesLoaded: false,
          scrollBusy: false,
          showModal: false,
          showChangeModal: false,
          searchCategoryDelay: false,
          instructor: null,
          requisites: []
        }
    },
    watch: {
      filters: {
        handler() {
          this.loadCourses();
        },
        deep: true
      },
      '$route'(to, from) {
        this.checkCategoriesFilters();
      },
      corporation() {
        this.get_Root_Css_Corporation();
      },
      user: function() {
       this.getUser();
      },
      categoriesCallback() {
        this.checkCategoriesFilters();
      },
    },
    filters: {
        toStartCase(str) {
          return _.startCase(str);
        }
    },
    computed: {
      ...mapState(['categories', 'user', 'listType']),
      _() {
          return _;
      },    
      async userData(){
        if(this.user){
          const response = await API.domain.crudDataUser({
              body: {
                id_user : this.user.id
              }
            });

            this.userData = response.data.User;
        }
      },
      async userData(){
        if(this.user){
          const response = await API.domain.crudDataUser({
              body: {
                id_user : this.user.id
              }
            });

            this.userData = response.data.User;
        }
      },
      hasCourses() {
        return !!this.courses.length;
      },
      CATEGORIES_TYPES() {
        return CATEGORIES_TYPES;
      },
      PAGES() {
        return PAGES;
      },
      showLoadBtn() {
          return this.count > this.courses.length;
      },
      corporationStyleColor() {
        let styles = {};
        const filtersColor = _.get(this, 'corporation.color_filters', null);

        if (filtersColor) {
          styles.color = filtersColor;
        }

        return styles;
      },
      colorFilters() {
        return _.get(this, 'corporation.color_filters', null);
      },
      categoriesValues() {
        return Object.values(this.$route.params);
      },
      hasInstructors() {
        return this.hasCategoriesFilters && this.$route.params.category === 'instructors' && !!this.$route.params.subcategory && this.$route.params.subcategory.match(/^(\d+-?)+\w+/gi);
      },
      hasCategoriesFilters() {
        return !!this.categoriesValues.length;
      },
    },
    methods: {
      $sanitize(content) {
        if (!content) return '';
        return DOMPurify.sanitize(content);
      },
      ...mapMutations(["setUser", 'changeType']),
      ...mapActions(['crudDataUser']),

      validationFullName(){
         let longFullName = this.userFirstName.split(" ");
         longFullName = longFullName.filter(x => x.trim() != "");

         if(this.userFirstName && this.userFirstName.trim().length > 0 && longFullName.length >= 2)
           return true;
         else
           return false;
      },
      async setFirstName(){
        let userFullName = this.userFirstName;
        this.userFirstName = '';

        if(userFullName && userFullName.length >= 2){

           var name_lastname = userFullName.split(" ");
		        var final_name = "";
		        var final_lastname = "";

		        switch(name_lastname.length){
		        case 1 :
		        	final_name = name_lastname[0]
		        	break;
		        case 2:
		        	final_name = name_lastname[0]
		        	final_lastname = name_lastname[1]
		        	break;
		        case 3 :
		        	final_name = name_lastname[0]
		        	final_lastname = name_lastname[1] +" "+name_lastname[2]
		        	break;
		        default :
		        	final_name = name_lastname[0] +" "+ name_lastname[1]
		        	final_lastname = name_lastname[2] +" "+name_lastname[3]
		        	break;
		        }

             if(!this.userData.people_work_phone){
              const responseData = await API.domain.crudDataUser({
                body: {
                  id_user : this.user.id
                }
              }); 
            
              this.userData = responseData.data.User; 

              this.userData.people_work_phone = responseData.data.People.people_work_phone;

            }

            this.userData.name = final_name;
            this.userData.lastname = final_lastname;
            this.userData.email = this.user.email;

           const response =  await API.domain.crudDataUser({
              body: {
                id_user : this.user.id,
                option : "save",
                data : JSON.stringify({user:this.userData,fields:{},fieldsCourse:[]})
              }
            });

            this.showModal = false;
            
            if(this.showChangeModal == true){
              this.showDialog = true;
            }

            this.$set(this.user, "first_name", this.userData.name);
            this.$set(this.user,"last_name", this.userData.lastname);
             if(this.userData.people_work_phone){
              this.$set(this.user,"people_work_phone", this.userData.people_work_phone);
            }
            this.setUser(this.user); 
            
        }

      },
      changeSharedWithMe(){

      	this.sharedWithMe = !this.sharedWithMe
      	this.loadCourses();

      },
      handleScroll() {
        if (this.$refs.filtersSection) this.showTopBtn = window.scrollY > (this.$refs.filtersSection.getBoundingClientRect().top - 150);
        if(this.showLoadBtn && !this.scrollBusy && this.$refs.loadMoreBtnContainer && this.$refs.loadMoreBtnContainer.getBoundingClientRect().top < 1000) {
          this.loadMore();
        }

        if(this.$refs.instructorCoursesFixed) {
          if(document.body.scrollTop > this.$refs.instructorCoursesContainer.offsetTop || document.documentElement.scrollTop > this.$refs.instructorCoursesContainer.offsetTop) {
            //this.$refs.instructorCoursesFixed.style.position = "fixed";
            //this.$refs.instructorCoursesFixed.style.top = "86px";
            //this.$refs.instructorCoursesFixed.style.width = "400px";
          } else {
            //this.$refs.instructorCoursesFixed.style.position = "absolute";
            //this.$refs.instructorCoursesFixed.style.top = "auto";
            //this.$refs.instructorCoursesFixed.style.width = "100%";
          }
        }
      },
      getPath(index) {
          let path = PAGES.LIST + "#";
          for (let i = 0; i <= index; i++) {
            path += '/' + this.categoriesValues[i];
          }

          return path;
      },
      refresh() {        
        this.loadCourses();       
      },
      async loadCourses(offset) {
        const loader = this.$loading.show();
        if(this.hasInstructors) {
          console.log('id_user', this.$route.params.subcategory.split('-')[0]);

          var response =   await API.domain.crudDataInstructor({
            body: {
              id_user: this.$route.params.subcategory.split('-')[0],
              id_corporation: this.corporation.id,
              option: "get",
            }
          });

          this.instructor = response.data;

          loader.hide();
          return
        }
        let filters = this.filters ? this.filters : DEFAULT_FILTERS;

        if (this.mainCategory && Object.keys(this.$route.params||{}).length > 0) {
          filters.categoryId = this.mainCategory.id_category;
        } else {
          delete filters.categoryId;
        }

        if(CATALOGUE_PATH){
        	filters.catalogue_path = CATALOGUE_PATH
        }

        filters.sharedWithMe = this.sharedWithMe
        filters.limit = this.limit;
        filters.offset = offset || 0;
        filters.sort = 'most recent';
        this.scrollBusy = true;
        const apiResponse = await API.main.getCourses(filters);

        if (offset) {
          this.courses = _.concat(this.courses, apiResponse.data.courses);
        } else {
          this.courses = apiResponse.data.courses;
        }

        this.count = apiResponse.data.count;
        this.coursesLoaded = true;
        this.scrollBusy = false;
        loader.hide();

        if (this.corporation && this.corporation.id) {
          getRootCssCorporation(this.corporation.id);
          if(this.corporation.id == 560 || this.corporation.id == 227){
             await this.getUser();
          }
        }
        
        
      },
      scrollTop() {
        window.scrollTo(0, 0);
      },
      filterOnlineCourses(valueItem) {
        if (valueItem.value) {
            if (this.filters) {
              this.filters.mode = 'online';
            } else {
              this.filters = {mode: 'online'};
            }
        } else if (this.filters) {
            this.filters.mode = null;
        }
      },
      /*changeType(listType) {
        this.listType = listType;
      },*/
      loadMore() {
        if(this.scrollBusy) { return; }
        this.loadCourses(this.courses.length);
      },
      /**loadCoursesDelayed() {
        if (this.searchCategoryDelay) {
          clearTimeout(this.searchCategoryDelay);
        }

        this.searchCategoryDelay = setTimeout(() => this.loadCourses(), 400);
      },**/
      checkCategoriesFilters() {
        if (this.hasCategoriesFilters) {
          this.searchCategory(_.last(this.categoriesValues));
        } else {
          this.loadCourses();
        }
      },
      get_Root_Css_Corporation(){
        console.log("Esto tiene corpo get_Root_Css_Corporation: ", this.corporation);
        if(this.corporation)
          getRootCssCorporation(this.corporation.id);
      },
      async searchCategory(nameFromUrl) {
        let idParentCategory = null;
        const categoryType = Object.keys(this.categories).filter(ct=>this.categories[ct].filter(c=>c.id_parent_category === null && c.search_field === this.$route.params.category).length)[0];
        if(categoryType) {
          for(let i = 0; i < this.categoriesValues.length; i++) {
            this.mainCategory = this.categories[categoryType].filter(c=>c.id_parent_category === idParentCategory && c.search_field === this.categoriesValues[i])[0];
            if(this.mainCategory) { idParentCategory = this.mainCategory.id_category; }
          }
        }

        this.loadCourses();
      },     
      async getUser(){
          let userId =  _.get(this.user, 'id', 0);
          console.log("esto es el id user: ", userId);
          // if(userId){
              console.log("esto tiene log user: ", _.get(this, 'user.id', 0));
              await API.domain.crudDataUser({
                body: {
                  id_user : 0
                }
              }).then((response) => {
                  if(response && response.data && response.data.User){
                  console.log("esto tiene user first name: ", response.data.User);
                  console.log("esto tiene isLoggedIn: ", this.isLoggedIn);
                  this.userData = response.data.User;

                  if(this.isLoggedIn && this.userData && this.userData.name && this.userData.lastname && (this.userData.name.toUpperCase() + this.userData.lastname.toUpperCase()) == 'YOURNAME'){
                      if(this.showDialog == true){
                        this.showChangeModal = true;
                        this.showDialog = false;
                      }                       
                      this.showModal = true;
                  }       
                  
                  this.userData.people_work_phone = response.data.People.people_work_phone;
                  
                  console.log("User Data : ", this.userData);
                  this.$set(this.user, "first_name", this.userData.name);
                  this.$set(this.user,"last_name", this.userData.lastname);
                  this.$set(this.user,"level_access", this.userData.level_access);
                  this.$set(this.user,"people_work_phone", response.data.People.people_work_phone);
                 
                  this.setUser(this.user);
                  }           

                  return this.user;  
              });                              
            // }     
      },
      showStartDate(course) {
        return moment(course.course_start_date, 'YYYY-MM-DD').isValid();
      },
      locationCity(location) {
        return [location.name, location.city].filter(v=>v).join(', ');
      },
      getPrice(seats) {
        if(seats.length === 0) {} else if(seats.length === 1) {
          return seats[0].id_course_seat_type === 1 ? `\$${seats[0].price}` : this.t('FREE');
        } else {
          let min = Math.min.apply(null, seats.map(v=>v.price));
          let max = Math.max.apply(null, seats.map(v=>v.price));
          return min === max && min === 0 ? this.t('FREE') : (min === 0 ? this.t('FREE') : `\$${min}`) + ` - \$${max}`;
        }
      },
      openCourse(course) {
        const loader = this.$loading.show();
        window.location.href = `/marketplace/courses/${course.id_course}`;
        loader.hide();
      },
    },
    async mounted() {
      // await this.getUser();
      window.addEventListener('scroll', this.handleScroll);     
    },
    async created() {
        // await this.getUser();
    },
    destroyed: function () {
      window.removeEventListener('scroll', this.handleScroll);
    },
}
</script>

<style lang="postcss" scoped>

.disabledFirstName.disabled, .disabledFirstName:disabled {
    color: #7e838a;
    background-color: #d5d8dc;
    border-color: transparent;
    border-radius: 4px;
     font-size: 16px;
}
.disabledFirstName{
   color: #7e838a;
    background-color: #d5d8dc;
    border-color: transparent;
    border-radius: 4px;
   cursor:pointer;
   width: 480px;
   height: 48px;
   display:flex;
   justify-content: center;
   align-items: center;
    font-size: 16px;
 }
 .enableFirstName:hover{
   background-color: #194a7d ;
   border-color: transparent;
   border-radius: 4px;
   box-shadow: 0px 4px 8px rgb(37 106 179 / 50%);
   cursor:pointer;
   color: white;
   width: 480px;
   height: 48px;
   display:flex;
   justify-content: center;
   align-items: center;
    font-size: 16px;
 }
 .enableFirstName{
   background-color: #256ab3;
   border-color: transparent;
   border-radius: 4px;
   box-shadow: 0px 4px 8px rgb(37 106 179 / 50%);
   cursor:pointer;
   font-size: 16px;
   color: white;
   width: 480px;
   height: 48px;
   display:flex;
   justify-content: center;
   align-items: center;
 }
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }

  .fade-enter, .fade-leave-to {
    opacity: 0;
  }

  @media (min-width: 1200px) {
    .container {
      width: 1170px;
      max-width: 1170px;
    }
  }

  .md-dialog {
    border-radius: 5px;
  }

  .modal-dialog.request-pay .modal-content {
    min-height: initial !important;
  }

  .search-area input:-moz-placeholder {
    font-size: 20px;
    font-style: italic;
    height: 60px;
    line-height: 26px;
  }

  .search-area input:-ms-input-placeholder {
    font-size: 20px;
    font-style: italic;
    height: 60px;
    line-height: 26px;
  }

  .search-area input::-moz-placeholder {
    font-size: 20px;
    font-style: italic;
    height: 60px;
    line-height: 26px;
  }

  .search-area input::-webkit-input-placeholder {
    font-size: 20px;
    font-style: italic;
    height: 60px;
    line-height: 26px;
  }
  
  .search-area input::placeholder {
    font-size: 20px;
    font-style: italic;
    height: 60px;
    line-height: 26px;
  }

  .btn-primary:not(:disabled):not(.disabled).active, .btn-primary:not(:disabled):not(.disabled):active, .show>.btn-primary.dropdown-toggle {
    border-color: transparent;
  }
  .filters-form .btn:hover {
    background-color: var(--corp-color);
  }

  .empty-section {
    min-height: 400px;
  }

  .empty-section .admin-btn,
  .empty-section .admin-btn:hover {
    width: fit-content;
    border-radius: 4px;
    /*background: linear-gradient(180deg,#faa63f,#f36d1e);*/
    background-color: rgba(var(--primaryColor));
    box-shadow: 0 10px 21px 0 rgba(243,113,32,.51);
    border: none;
    cursor: pointer;
    color: var(--primaryText) !important;
    font-family: Source Sans Pro;
    font-size: 25px;
    line-height: 32px;
    text-align: center;
    display: block;
    padding: 15px 20px;
    margin: auto;
    text-decoration: none !important;
  }

  .empty-section img {
    height: 248px;
    width: 342px;
  }

  .empty-section h3 {
    color: #383838;
    font-family: "Source Sans Pro";
    font-size: 40px;
    line-height: 46px;
    text-align: center;
  }

  .empty-section p {
    color: #383838;
    font-family: "Source Sans Pro";
    font-size: 18px;
    line-height: 22px;
    text-align: center;
  }

  .empty-section a.link {
    color: #256AB3;
  }

  .views-selection label {
    width: 35px;
  }

 

  span.switch-text {
    font-family: "Source Sans Pro";
    font-size: 18px;
    line-height: 22px;
  }

  .btn-outline-primary {
    
  }

  .btn-outline-primary:active,
  .btn-outline-primary:hover {
    
  }

  .top-circle {
    border-radius: 50%;
    bottom: 4.3125rem;
    cursor: pointer;
    font-size: 16px;
    height: 40px;
    letter-spacing: normal;
    line-height: 40px;
    position: fixed;
    right: 1.5rem;
    text-align: center;
    width: 40px;
    z-index: 1;
  }


  .top-circle /deep/ i.fa {
    font-size: 1rem;
    line-height: 1;
  }

  h1.category-title {
    color: #FFFFFF;
    font-family: "Source Sans Pro";
    font-size: 35px;
    line-height: 44px;
    text-shadow: 0 2px 2px rgba(0,0,0,0.5);
    bottom: 30px;
    left: 40px;
  }

  h1.competences-title {
    color: #474747;
    font-family: "Source Sans Pro";
    font-size: 35px;
    line-height: 44px;
  }

  .breadcrumb-item.active {
    height: 22px;
    color: #383838;
    font-family: "Source Sans Pro";
    font-size: 16px;
    line-height: 22px;
  }

  .filters-form {
    background-color: rgb(227,229,232);
  }

  .no-results {
    max-width: 380px;
  }
  .no-results /deep/ h1 {
    color: rgb(56,56,56);
    font-family: "Source Sans Pro";
    font-size: 30px;
    line-height: 38px;
    margin-bottom: 6px;
  }

  .no-results /deep/ p {
    color: rgb(56,56,56);
    font-family: "Source Sans Pro";
    font-size: 16px;
    line-height: 20px;
    margin-bottom: 0;
  }
  .cards-container /deep/ .card-container .card .img-wrapper .course-flags {
    font-family: "Source Sans Pro";
    font-size: 12px;
    font-weight: 600;
    top: 70px;
    right: -8px;
  }
  .instructor-header {
    align-items: center;
    color: rgb(255, 255, 255);
    background-color: rgb(38, 50, 56);
    gap: 48px;
    padding: 32px;
    text-align: center;
  }
  .instructor-header /deep/ img.rounded-circle {
    border: 1px solid rgb(255, 255, 255);
  }
  .instructor-header /deep/ .instructor-name {
    font-size: 35px;
    line-height: 43px;
    margin-bottom: 8px;
  }
  .instructor-header /deep/ .instructor-summary {
    font-size: 16px;
    line-height: 20px;
  }
  .instructor-header /deep/ .instructor-summary p {
    color: rgb(255, 255, 255);
    font-size: 16px;
    line-height: 20px;
    margin-bottom: 0;
  }
  .instructor-title {
    color: rgb(38, 50, 56);
    font-size: 24px;
    line-height: 48px;
  }

  .instructor-description {
    color: rgb(38, 50, 56);
    font-size: 16px;
    line-height: 26px;
    margin-bottom: 40px;
  }
  .instructor-data {}
  .instructor-data /deep/ .instructor-social {}
  .instructor-courses-container {
    position: relative;
  }
  .instructor-courses-container /deep/ .instructor-courses {
    background-color: rgb(246, 246, 246);
    border-radius: 4px;
    padding: 25px;
  }
  .instructor-courses-container /deep/ .instructor-courses .instructor-title {
    font-size: 24px;
    line-height: 30px;
    margin-bottom: 34px;
  }
  .instructor-courses-container /deep/ .instructor-courses .instructor-course {
    align-items: center;
    border-bottom: rgb(144, 164, 174) solid 1px;
    cursor: pointer;
    display: grid;
    padding-bottom: 16px;
    margin-bottom: 16px;
  }

  .instructor-courses-container /deep/ .instructor-courses .instructor-course.has-date {
    grid-template-columns: 55px 1fr;
    gap: 16px;
  }
  .instructor-courses-container /deep/ .instructor-courses .instructor-course .instructor-course-cal {}
  .instructor-courses-container /deep/ .instructor-courses .instructor-course .instructor-course-cal .instructor-course-cal-month {
    background-color: rgb(217, 90, 75);
    border-top-left-radius: 4px;
    color: rgb(255, 255, 255);
    font-size: 12px;
    line-height: 20px;
    text-align: center;
    text-transform: uppercase;
  }
  .instructor-courses-container /deep/ .instructor-courses .instructor-course .instructor-course-cal .instructor-course-cal-day {
    color: rgb(38, 50, 56);
    background-color: rgb(255, 255, 255);
    font-size: 24px;
    line-height: 32px;
    text-align: center;
  }
  .instructor-courses-container /deep/ .instructor-courses .instructor-course .instructor-course-cal .instructor-course-cal-hour {
    color: rgb(38, 50, 56);
    background-color: rgb(255, 255, 255);
    border-bottom-right-radius: 4px;
    font-size: 12px;
    line-height: 18px;
    text-align: center;
  }
  .instructor-courses-container /deep/ .instructor-courses .instructor-course .instructor-course-title {
    color: rgb(38, 50, 56);
    font-size: 17px;
    line-height: 21px;
    margin-bottom: 8px;
  }
  .instructor-courses-container /deep/ .instructor-courses .instructor-course .instructor-course-type {
    align-items: center;
    color: rgb(56, 56, 56);
    display: grid;
    grid-template-columns: 18px 1fr;
    gap: 4px;
    font-size: 12px;
    line-height: 26px;
    margin-bottom: 5px;
  }
  .instructor-courses-container /deep/ .instructor-courses .instructor-course .instructor-course-price {
    color: rgb(56, 56, 56);
    font-size: 14px;
    line-height: 20px;
    margin-bottom: 0;
  }
  @media (min-width: 992px) {
    .instructor-header {
      display: grid;
      grid-template-columns: 320px 1fr; 
    }

    .instructor-data {
      display: grid;
      grid-template-columns: 1fr 400px;
      gap: 16px;
    }
    .instructor-courses-container /deep/ .instructor-courses {
      position: absolute;
      width: 100%;
      z-index: 1;
    }
    .instructor-header /deep/ .instructor-name,
    .instructor-header /deep/ .instructor-summary,
    .instructor-data /deep/ .instructor-social {
      text-align: start;
    }
  }
</style>